import React, { useState, useEffect } from "react";
import SubHeader from "../../layout/components/SubHeader";
import { KTSVG } from "../../helpers/KTSVG";
import { KTIcon } from "../../helpers";
import { Link } from "react-router-dom";
import FileCard from "./FileCard";
import mediaService from "../../../services/media.service";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import { toast } from "react-toastify";
import clsx from "clsx";
import Loading from "../../common/Loading";
import { Tooltip } from "react-tooltip";
import { Modal } from "react-bootstrap";

const MAX_FILE_SIZE_MB = 16;
const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/svg+xml",
  "image/webp",
  "image/x-icon",
  "image/jpeg2000",
  "image/heif",
  "image/heic",
  "image/x-raw",
  "image/x-pgf",
  "application/pdf",
  "application/x-pdf",
];
function MyFiles() {
  const user = useEyeconxStore((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [serverFiles, setServerFiles] = useState([]);
  const [SubHeaderString, setSubHeaderString] = useState(null);
  const [sortStatus, setSortStatus] = useState("unsorted");
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);
  useEffect(() => {
    getFiles();
    getDetails();
  }, []);

  const getFiles = () => {
    mediaService
      .getResources(user.clinicId)
      .then((res) => {
        setServerFiles(res.data);
        setFileList(res.data);
      })
      .catch((err) => {
        console.log("Error");
        console.log(err);
      });
  };
  const getDetails = () => {
    mediaService
      .getDetails(user.clinicId)
      .then((res) => {
        let sub_header =
          "Size : " + res.data.size + " | Total Files : " + res.data.totalFiles;
        setSubHeaderString(sub_header);
      })
      .catch((err) => {
        console.log("Error in GetDetails");
        console.log(err);
      });
  };

  const handleAscendingClick = () => {
    setLoading(true);
    setSortStatus("ascending");
    const sortedAscending = fileList
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
    setFileList(sortedAscending);
    setTimeout(() => {
      setLoading(false);
    }, 800);
  };
  const handleDescendingClick = () => {
    setLoading(true);
    setSortStatus("descending");
    const sortedDescending = fileList
      .slice()
      .sort((a, b) => b.name.localeCompare(a.name));
    setFileList(sortedDescending);
    setTimeout(() => {
      setLoading(false);
    }, 800);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    // Call the search function with the current search term
    const results = searchByName(value);
    //setSearchResults(results);
    setFileList(results);
  };

  // Function to search data by name
  const searchByName = (query) => {
    // Convert query to lowercase for case-insensitive search
    const lowerCaseQuery = query.toLowerCase();

    // Filter the data based on the name containing the query
    const results = serverFiles.filter((item) =>
      item.name.toLowerCase().includes(lowerCaseQuery)
    );

    return results;
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setFileList(serverFiles);
  };

  const handleLatestClick = () => {
    setLoading(true);
    // Sort by createdAt date with the latest first
    const sortedLatestFirst = fileList
      .slice()
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    setSortStatus("latest");
    setFileList(sortedLatestFirst);
    setTimeout(() => {
      setLoading(false);
    }, 800);
  };
  const handleOldestClick = () => {
    setLoading(true);
    // Sort by createdAt date with the oldest first
    const sortedOldestFirst = fileList
      .slice()
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    setFileList(sortedOldestFirst);
    setSortStatus("oldest");
    setTimeout(() => {
      setLoading(false);
    }, 800);
  };
  const refreshList = () => {
    setLoading(true);
    setFileList([])
    
    getFiles();
    getDetails();
    setTimeout(() => {
      setLoading(false);
    }, 800);
  };
  const handleUpload = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      //axios upload file
      try {
        const response = await mediaService.uploadMedia(
          user.clinicId,
          formData,
          (progressEvent) => {
            const progress = (progressEvent.loaded / progressEvent.total) * 100;
            setUploadProgress(progress);
          }
        );
        setSelectedFile(null);
        toast.success("File Uploaded Succesfully");
        refreshList();
        setUploadProgress(0);
      } catch (error) {
        setSelectedFile(null);
        toast.error("Error while uploading File !");
      }
    } else {
      console.log("No file selected");
    }
    handleModalClose();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      setError("Invalid File Type. Please upload JPEG,PNG, GIF or PDF");
      return;
    }
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setError(
        `File size exceeds ${MAX_FILE_SIZE_MB} MB. Please choose a smaller file.`
      );
      return;
    }
    setSelectedFile(file);
    setError(null);
  };
  return (
    <>
      <SubHeader title="Files" description={SubHeaderString && SubHeaderString}>
        {/* Search Bar & Upload Button */}
        <div className="d-flex flex-row justify-content-end align-items-center mt-3">
          <div className="d-flex align-items-center position-relative me-4 mb-2">
            <KTIcon
              iconName="magnifier"
              className="fs-3 position-absolute ms-3"
            />
            <input
              type="text"
              placeholder="Search Files"
              className="form-control form-control-sm me-2 form-control-solid w-150px ps-10"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          <button
            onClick={handleModalShow}
            className="btn btn-light-primary d-flex btn-sm flex-row justify-content-center mb-2"
          >
            <KTSVG
              path="media/icons/duotune/files/fil018.svg"
              className="svg-icon-1 me-1"
            />
            <span className="d-none d-md-inline">Upload Files</span>
          </button>

          <button
            data-tooltip-id="tt_options"
            data-tooltip-place="bottom-start"
            className="btn btn-outline btn-sm btn-icon-info ms-3 mb-2"
          >
            <KTSVG
              path="media/icons/duotune/general/gen053.svg"
              className="svg-icon-1 "
            />
          </button>
          <Tooltip
            id="tt_options"
            clickable
            className="bg-secondary"
            style={{ zIndex: "107" }}
          >
            <div className="d-flex flex-column">
              <span className="text-gray-800">Sort by name</span>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "ascending",
                })}
                onClick={handleAscendingClick}
              >
                <i className="bi bi-sort-alpha-down fs-4"> </i> Ascending
              </button>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "descending",
                })}
                onClick={handleDescendingClick}
              >
                <i className="bi bi-sort-alpha-up fs-4"> </i> Descending
              </button>
              <span className="text-gray-800">Sort by date</span>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "latest",
                })}
                onClick={handleLatestClick}
              >
                <i className="bi bi-arrow-down fs-4"> </i> Latest
              </button>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "oldest",
                })}
                onClick={handleOldestClick}
              >
                <i className="bi bi-arrow-up fs-4"> </i> Oldest
              </button>
            </div>
          </Tooltip>
        </div>
      </SubHeader>

      <div className="app-container">
        {searchTerm && (
          <div className="row mb-2">
            <div className="col-12 d-flex justify-content-end align-items-center">
              <button
                className="btn btn-warning btn-sm"
                onClick={handleClearSearch}
              >
                {" "}
                <i className="bi bi-x-circle-fill fs-3"></i> Clear Search
              </button>
            </div>
          </div>
        )}
        {loading ? (
          <Loading />
        ) : (
          <div className="row">
            {fileList.map((item, index) => {
              return (
                <FileCard key={index} item={item} refreshList={refreshList} />
              );
            })}
          </div>
        )}

        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Select Media</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Add your upload form or component here */}
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="image-file-input"
            />
            <label htmlFor="image-file-input">
              <span className="btn  btn-light-primary">
                Select Image / PDF from Computer
              </span>
            </label>
            <p className="text-muted mb-3">Allowed file types : gif, png, jpg, jpeg, bmp, pdf</p>
            {selectedFile && (
              <>
                <div className="text-dark mt-2">{selectedFile.name}</div>
              </>
            )}
           
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-light-success" onClick={handleUpload}>
              Upload Selected
            </button>
            <button className="btn btn-light-secondary">Cancel</button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default MyFiles;
